import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Box from 'ui-box';
import AntdAlertErrorBoundary from '../../components/common/AntdAlertErrorBoundary';
import MobileHeader from '../../components/mobile/Header';
import SelectContactGuestScreen from '../../pages/mobile/sign-up/guest/SelectContactGuestScreen';
import SignupRemainderScreen from '../../pages/mobile/sign-up/guest/SignupRemainderScreen';
import LocationAccessRequestScreen from '../../pages/mobile/sign-up/guest/LocationAccessRequestScreen';
import ScreeningRequestScreen from '../../pages/mobile/sign-up/guest/ScreeningRequestScreen';
import FinishScreen from '../../pages/mobile/sign-up/guest/FinishScreen';
import AddFamilyMemberScreen from '../../pages/mobile/sign-up/guest/AddFamilyMemberScreen';
import ThankYouScreen from '../../pages/mobile/sign-up/ThankYouScreen';
import TakeHealthScreeningScreen from '../../pages/mobile/sign-up/guest/TakeHealthScreeningScreen';

function MobileSignupGuestLayout() {

  return (
    < >
      <Box position="relative" height="100%">
        <AntdAlertErrorBoundary>
          <MobileHeader />
        </AntdAlertErrorBoundary>
        <AntdAlertErrorBoundary>
          <Box paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
            <Switch>
              <Route path="/sign-up/guest/take-health-screening">
                <TakeHealthScreeningScreen />
              </Route>
              <Route path="/sign-up/guest/add-family-member">
                <AddFamilyMemberScreen />
              </Route>
              <Route path="/sign-up/guest/finish">
                <FinishScreen />
              </Route>
              <Route path="/sign-up/guest/screening-request">
                <ScreeningRequestScreen />
              </Route>
              <Route path="/sign-up/guest/location-access-request">
                <LocationAccessRequestScreen />
              </Route>
              <Route path="/sign-up/guest/thank-you">
                <ThankYouScreen />
              </Route>
              <Route path="/sign-up/guest/remainder">
                <SignupRemainderScreen />
              </Route>
              <Route path="/sign-up/guest">
                <SelectContactGuestScreen />
              </Route>
            </Switch>
          </Box>
        </AntdAlertErrorBoundary>
      </Box>
    </>
  );
}

export default MobileSignupGuestLayout;
